const config = {
  apiBaseUrl:
    // import.meta.env.VITE_API_BASE_URL ||
    // "https://beta.ofcourse.com.br/api",
    import.meta.env.VITE_API_BASE_URL || "http://localhost:5259/api",
  mockBaseUrl: "http://localhost:5259/api",
  videoUrl: "media/video",
  useRealApi: import.meta.env.VITE_USE_REAL_API === 'true' || true, // Usar variável de ambiente ou true por padrão
  /** Level test: show progress/debug panel. Only VITE_LEVEL_TEST_SHOW_PROGRESS_PANEL === 'true' shows it; default is not to show. */
  showLevelTestProgressPanel: import.meta.env.VITE_LEVEL_TEST_SHOW_PROGRESS_PANEL === 'true',
  mockServices: ['special-access-user'] as string[], // lista de serviços que usam mock
  defaultTimeout: 60000, // 60 seconds - timeout padrão para todas as requisições HTTP
  selectApi: <TArgs extends unknown[], TReturn>(
    realApi: (...args: TArgs) => TReturn,
    mockApi: (...args: TArgs) => TReturn
  ): ((...args: TArgs) => TReturn) => {
    return config.useRealApi ? realApi : mockApi;
  },
};

// config.mockServices = ["level-tests", "level-test-groups"];

export default config;
